<template>
  <div class="buddi-test">
    <h2>Test de l'assistant Buddi</h2>
    <button @click="directShowTest">Test direct (state.visible = true)</button>
    <button @click="serviceShowTest">Test service ($buddiAssistant.show)</button>
    <button @click="toggleStateTest">Toggle state ({{ isVisible ? 'Hide' : 'Show' }})</button>
    
    <div v-if="isVisible" class="test-modal">
      <div class="test-modal-content">
        <h3>Modale de test</h3>
        <p>Cette modale est contrôlée directement par l'état réactif.</p>
        <button @click="isVisible = false">Fermer</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance} from 'vue'

export default {
  name: 'BuddiTest',
  setup() {    
    const { proxy } = getCurrentInstance();
    
    // État local pour le test
    const isVisible = ref(false);
    
    // Fonction pour tester l'affichage direct en modifiant l'état
    const directShowTest = () => {
      if (proxy.$buddiAssistantState) {
        proxy.$buddiAssistantState.visible = true;
        proxy.$buddiAssistantState.title = 'Test Direct';
        proxy.$buddiAssistantState.messages = ['Message de test direct'];
        proxy.$buddiAssistantState.options = [
          { text: 'Option de test', responses: ['Réponse de test'] }
        ];
      }
    };
    
    // Fonction pour tester le service show()
    const serviceShowTest = () => {
      if (proxy.$buddiAssistant) {
        proxy.$buddiAssistant.show({
          title: 'Test Service',
          messages: ['Message de test via service'],
          options: [
            { text: 'Option de test service', responses: ['Réponse de test service'] }
          ]
        });
      }
    };
    
    // Fonction pour basculer l'état local de visibilité
    const toggleStateTest = () => {
      isVisible.value = !isVisible.value;
    };
    
    return {
      isVisible,
      directShowTest,
      serviceShowTest,
      toggleStateTest
    };
  }
}
</script>

<style scoped>
.buddi-test {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.buddi-test button {
  background-color: #016e7e;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin: 0.5rem;
}

.buddi-test button:hover {
  background-color: #004b55;
}

.test-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.test-modal-content {
  background-color: #1a202c;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 500px;
}

.test-modal-content h3 {
  margin-bottom: 1rem;
}

.test-modal-content button {
  margin-top: 1rem;
}
</style>
